<template>
  <div class="newsletters">
    <!-- News-Letter-Section-Start -->
    <section class="newsletter_section">
      <!-- container start -->
      <div class="container">
        <div class="newsletter_box">
          <div
            class="section_title"
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <!-- h2 -->
            <h2>Subscribe to Our Newsletter</h2>
            <!-- p -->
            <p>Be the first to discover new braid trends, exclusive offers, and pro tips from top stylists — straight to your inbox.</p>
          </div>
          <form
            action="#"
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                placeholder="Enter your email"
              />
            </div>
            <div class="form-group">
              <button class="btn">SUBMIT</button>
            </div>
          </form>
        </div>
      </div>
      <!-- container end -->
    </section>
    <!-- News-Letter-Section-end -->
  </div>
</template>

<script>
export default {
  name: "NewsletterBox",
};
</script>

<style scoped>
.newsletter_box h2{font-size:30px;}

.newsletter_box p{font-size:13px; line-height: 1.25;}
</style>
